const STATE_ROOT = "tdinventario";

export const loadState = () => {
  const serializedState = localStorage.getItem(STATE_ROOT);

  try {
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STATE_ROOT, serializedState);
  } catch (e) {
    console.log("The store cant be parsed from localstorage");
  }
};
